<template>
  <div class="main-container">
    <header
      class="library-page-header library-page-header--bilancio"
      aria-labelledby="library-page-title-bilancio"
    >
      <span class="library-page-header__icon" aria-hidden="true">
        <LibraryIcon library="bilanci" />
      </span>
      <div class="library-page-header__copy">
        <div class="library-page-header__title-row">
          <h1
            id="library-page-title-bilancio"
            class="library-page-header__title"
          >
            Libreria Bilanci Analitici
          </h1>
          <span class="library-scope-badge is-shared">
            <i class="fa-solid fa-users" aria-hidden="true"></i>
            Condivisa con il tuo studio
          </span>
        </div>
        <p class="library-page-header__subtitle">
          Gestisci i file condivisi dei clienti per il Bilancio Analitico del
          tuo studio.
        </p>
      </div>
      <img
        class="library-page-header__visual library-page-header__visual--bilancio"
        src="/Titoli pagine/Immagine Libreria bilanci analitici.png"
        alt=""
        aria-hidden="true"
      />
    </header>
    <div class="libreria-bilanci library-workspace">
      <!-- File Selector Section -->
      <section
        class="selector-container"
        :class="{ collapsed: isSelectorCollapsed }"
        v-if="isDataLoaded"
      >
        <div class="selector-header">
          <div class="header-title">
            <span class="clients-title-icon" aria-hidden="true">
              <i class="fa-solid fa-users"></i>
            </span>
            <h3>Clienti del tuo studio</h3>
            <span v-if="!isLibraryEmpty" class="client-count">
              {{ Object.keys(clientiFiles).length }}
            </span>
          </div>
          <div class="toolbar">
            <button
              class="add-button"
              @click="openAddModal"
              title="Aggiungi Cliente"
            >
              <i class="fas fa-plus"></i>
              Aggiungi cliente
            </button>
            <button
              class="layout-button"
              @click="toggleLayout"
              :title="isRowLayout ? 'Vista in colonna' : 'Vista in riga'"
            >
              <i
                :class="[
                  'fas',
                  isRowLayout ? 'fa-grip-vertical' : 'fa-grip-horizontal',
                ]"
              ></i>
            </button>
            <button
              class="espandi-button"
              @click="toggleSelector"
              title="Espandi/Comprimi"
            >
              <i
                :class="[
                  'fas',
                  isSelectorCollapsed ? 'fa-expand' : 'fa-compress',
                ]"
              ></i>
            </button>
          </div>
        </div>
        <div
          class="selector-content"
          :class="{ 'selector-content--empty': isLibraryEmpty }"
          v-show="!isSelectorCollapsed"
        >
          <div v-if="isLibraryEmpty" class="empty-library-state">
            <div class="empty-library-icon" aria-hidden="true">
              <i class="fa-solid fa-table-list"></i>
            </div>
            <div class="empty-library-body">
              <p class="empty-library-title">Crea la tua Libreria Clienti</p>
              <p class="empty-library-line">
                Non ci sono ancora clienti salvati. Verranno aggiunti
                automaticamente usando il Convertitore Bilancio Analitico.
                <br />
                Per ogni cliente puoi salvare il Piano dei Conti e l'Archivio
                Clienti e Fornitori.
              </p>
              <div class="empty-library-actions">
                <router-link
                  class="empty-library-action empty-library-action--primary"
                  to="/home/bilancio-analitico"
                  title="Vai al convertitore Bilancio Analitico"
                >
                  <i class="fa-solid fa-wand-magic-sparkles"></i>
                  Usa convertitore
                </router-link>
                <button
                  class="empty-library-action empty-library-action--secondary"
                  type="button"
                  @click="openAddModal"
                >
                  <i class="fas fa-plus"></i>
                  Aggiungi cliente
                </button>
              </div>
            </div>
          </div>
          <ul v-else class="tree-view" :class="{ 'row-layout': isRowLayout }">
            <li
              v-for="(files, cliente) in clientiFiles"
              :key="cliente"
              class="folder-item"
              :class="{
                'is-open': isFolderOpen(cliente),
                'menu-open': showMenu && menuClient === cliente,
              }"
            >
              <div
                class="folder-header"
                @click="toggleFolder(cliente)"
                :class="{ 'menu-open': showMenu && menuClient === cliente }"
              >
                <span>
                  <i
                    :class="[
                      'fas',
                      isFolderOpen(cliente) ? 'fa-folder-open' : 'fa-folder',
                    ]"
                  ></i>
                  {{ clientLabel(cliente) }}
                  <i
                    class="fas fa-chevron-down"
                    v-if="!isFolderOpen(cliente)"
                  ></i>
                  <i class="fas fa-chevron-up" v-if="isFolderOpen(cliente)"></i>
                </span>

                <!-- ELLIPSIS ICON -->
                <div
                  class="ellipsis-wrapper"
                  @click.stop.prevent="openMenu(cliente, $event)"
                >
                  <i class="fa-solid fa-ellipsis"></i>

                  <!-- CONTEXT MENU -->
                  <div
                    v-if="showMenu && menuClient === cliente"
                    class="context-menu"
                    :style="{ top: menuY + 'px', left: menuX + 'px' }"
                    @click.stop
                  >
                    <ul>
                      <li @click.stop="openDeleteConfirm">
                        <i class="fa-solid fa-trash-can"></i> Elimina
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <ul v-if="isFolderOpen(cliente)" class="file-list">
                <li
                  v-for="file in files"
                  :key="file"
                  class="file-item"
                  :class="{
                    active:
                      selectedCliente === cliente && selectedFile === file,
                  }"
                  @click="selectFile(cliente, file)"
                >
                  <i class="fas fa-file-excel"></i>
                  <span>{{ displayBilancioFileName(file) }}</span>
                </li>
                <li v-if="!hasPiano(files)" class="no-files-message">
                  Nessun Piano dei Conti presente
                  <button
                    class="add-file-button"
                    @click="triggerAddPiano(cliente)"
                    title="Aggiungi Piano dei Conti"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </li>
                <li v-if="!hasAnagrafica(files)" class="no-files-message">
                  Nessun Archivio Clienti e Fornitori presente
                  <button
                    class="add-file-button"
                    @click="triggerAddAnagrafica(cliente)"
                    title="Aggiungi Archivio Anagrafica"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </section>

      <!-- Visualizer Section -->
      <section class="content" v-if="isDataLoaded && !isLibraryEmpty">
        <div class="tableheader" v-if="selectedFile">
          <div class="selected-file-heading">
            <span class="selected-file-icon" aria-hidden="true">
              <i
                :class="
                  selectedFileType === 'piano'
                    ? 'fa-solid fa-table-list'
                    : 'fa-solid fa-address-book'
                "
              ></i>
            </span>
            <div>
              <span class="selected-file-client">{{
                clientLabel(selectedCliente)
              }}</span>
              <h3 class="selectedFile">{{ fileTypeTitle }}</h3>
            </div>
          </div>
          <button
            v-if="jsonData.length > 0"
            @click="closePDC"
            title="Chiudi File"
            class="closePDC"
            type="button"
            aria-label="Chiudi file"
          >
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>

        <div v-if="jsonData.length > 0" class="table-container">
          <div class="dashboard">
            <div class="buttons" v-if="jsonData.length > 0" ref="dashboardRef">
              <!-- Pulsanti dashboard (invariati) -->
              <button
                class="btninput addRowButton"
                :class="{ 'active-button': isEditing }"
                :disabled="!jsonData.length"
                @click="isEditing = !isEditing"
              >
                <i class="fa-solid fa-pen-to-square toolicon"></i> Modifica
              </button>
              <div class="download-menu">
                <button
                  class="btninput action-button download-menu-trigger"
                  type="button"
                  :disabled="!selectedFile"
                >
                  <i class="fas fa-download toolicon"></i> Scarica
                  <i class="fa-solid fa-chevron-down download-menu-chevron"></i>
                </button>
                <div class="download-menu-dropdown">
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="downloadFile"
                    :disabled="!selectedFile"
                  >
                    <i class="fas fa-file-excel"></i> File attuale
                  </button>
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="scaricaModelloFileSelezionato"
                    :disabled="!selectedFileType"
                  >
                    <i class="fas fa-file-excel"></i> Modello vuoto
                  </button>
                </div>
              </div>
              <button
                class="btninput action-button"
                :class="{ uploadingPBA: uploading }"
                @click="triggerFileReplace"
                :disabled="uploading || !ha(user, 'funzione_carica_piano')"
                :title="
                  !ha(user, 'funzione_carica_piano')
                    ? 'Carica un nuovo file manualmente - Disponibile da piano Plus'
                    : 'Carica un nuovo file manualmente'
                "
              >
                <i class="fas fa-upload toolicon"></i>
                {{ uploading ? "Elaborazione" : "Sostituisci" }}
                <i
                  v-if="!ha(user, 'funzione_carica_piano')"
                  class="fa-solid fa-lock lock-icon"
                ></i>
              </button>
              <button
                class="btninput action-button"
                @click="deleteFile"
                :disabled="!selectedFile"
              >
                <i class="fas fa-trash toolicon"></i> Elimina
              </button>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: hasUnsavedChanges }"
                title="Salva modifiche"
                @click="saveChanges($event)"
                :disabled="!jsonData.length"
              >
                <i
                  class="fa-solid fa-floppy-disk savebutton"
                  :class="{ unsaved: hasUnsavedChanges }"
                ></i>
                <span>Salva</span>
              </button>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: hasUnsavedChanges }"
                title="Annulla modifiche"
                @click="cancelChanges"
                :disabled="!jsonData.length"
              >
                <i
                  class="fa-solid fa-xmark cancelbutton"
                  :class="{ unsaved: hasUnsavedChanges }"
                ></i>
                <span>Annulla</span>
              </button>
              <input
                type="file"
                ref="fileInput"
                class="hidden-file-input"
                accept=".xlsx,.csv"
                @change="replaceFile"
              />
            </div>
            <div v-if="jsonData.length > 0" class="ultimamodifica">
              <span v-if="noChangesMessage" class="nochanges-message">
                Nessuna modifica presente
              </span>
              <span class="ultimamodificatext">
                Ultima modifica: {{ lastModified }}
              </span>
            </div>
          </div>

          <!-- Tabella -->
          <table
            id="excelTable"
            :key="tableKey"
            ref="exceltableRef"
            :class="{ editing: isEditing }"
          >
            <!-- ... tabella invariata ... -->
            <tr
              v-for="(row, rowIndex) in jsonData"
              :key="rowIndex"
              :class="[
                'riga',
                {
                  'header-row': rowIndex === 0,
                  'row-deleting': deletedRows[rowIndex],
                  'highlight-row':
                    !deletedRows[rowIndex] &&
                    (hoveredRow === rowIndex || hoveredRow === 'all') &&
                    rowIndex !== 0,
                  'provisional-row':
                    !deletedRows[rowIndex] &&
                    provisionalRows.includes(rowIndex),
                },
              ]"
            >
              <!-- Colonna indice riga (sempre visibile) -->
              <th v-if="rowIndex === 0" class="row-index"></th>
              <td v-else class="row-index">{{ rowIndex }}</td>

              <!-- Celle normali con v-show basato su visibleColumns -->
              <template v-for="(cell, colIndex) in row">
                <th
                  v-if="rowIndex === 0"
                  v-show="visibleColumns[colIndex]"
                  :key="colIndex"
                  @dblclick="toggleEditing"
                >
                  {{ cell }}
                </th>

                <td
                  v-else
                  v-show="visibleColumns[colIndex]"
                  :key="colIndex"
                  :contenteditable="
                    isEditing && isEditableColumntable(colIndex)
                  "
                  @dblclick="toggleEditing"
                  @input="
                    updateCell(rowIndex, colIndex, $event.target.textContent)
                  "
                  :class="{
                    'highlight-cell': isCellModified(rowIndex, colIndex),
                    'modified-cell':
                      modifiedCells[`${rowIndex}-${colIndex}`] &&
                      !errors[`${rowIndex}-${colIndex}`],
                    'error-cell': errors[`${rowIndex}-${colIndex}`],
                    'has-hidden-description':
                      colIndex === 1 &&
                      row[1] !== row[0] &&
                      selectedFileType === 'piano',
                    'italic-none': cell === 'N.A.',
                  }"
                >
                  {{ cell }}
                  <div
                    v-if="
                      tooltip.visible &&
                      tooltip.rowIndex === rowIndex &&
                      colIndex === 1 &&
                      selectedFileType === 'piano'
                    "
                    class="custom-tooltip"
                  >
                    Descrizione associata a:
                    <span class="desc-originale">{{ tooltip.content }}</span>
                  </div>
                </td>
              </template>

              <!-- Colonna elimina (sempre visibile quando in editing) -->
              <td v-if="isEditing && rowIndex === 0" class="delete-column"></td>
              <td v-if="isEditing && rowIndex !== 0" class="delete-column">
                <button
                  v-if="isEditing"
                  title="Elimina riga"
                  class="delete-button"
                  :class="{ active: activeDelete[rowIndex] }"
                  @click="deleteRow(rowIndex, $event)"
                  @mouseenter="hoveredRow = rowIndex"
                  @mouseleave="hoveredRow = null"
                >
                  🗑️
                </button>
              </td>
            </tr>
            <div v-if="jsonData.length == 1" class="noRowsPDC">
              <p>Nessun dato presente</p>
            </div>
          </table>
        </div>

        <div v-else-if="selectedFile" class="table-loading-state">
          <i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i>
          <span>Caricamento file in corso...</span>
        </div>
        <div v-else class="file-selection-empty">
          <span class="file-selection-empty-icon" aria-hidden="true">
            <i class="fa-solid fa-folder-open"></i>
          </span>
          <div>
            <strong>Seleziona un file</strong>
            <p>
              Apri un cliente e scegli il Piano dei Conti o l’Archivio Clienti e
              Fornitori da consultare.
            </p>
          </div>
        </div>
      </section>

      <!-- MODAL DI CONFERMA -->
      <LibraryDeleteModal
        v-if="confirmModalConfirmClass === 'btn-danger'"
        :visible="confirmModalVisibile"
        :title="confirmModaltitle || 'Elimina file dalla libreria'"
        :message="confirmModalMessaggio"
        :confirm-label="confirmModalConfirmLabel"
        :cancel-label="confirmModalCancelLabel"
        @cancel="confirmModalCallback && confirmModalCallback(false)"
        @confirm="confirmModalCallback && confirmModalCallback(true)"
      />
      <div v-else-if="confirmModalVisibile" class="modal">
        <div class="modal-content">
          <h2>{{ confirmModaltitle }}</h2>
          <p class="deletemessage">{{ confirmModalMessaggio }}</p>
          <button
            @click="confirmModalCallback(false)"
            class="btn-modal btn-secondary"
          >
            {{ confirmModalCancelLabel }}
          </button>
          <button
            @click="confirmModalCallback(true)"
            class="btn-modal"
            :class="confirmModalConfirmClass"
          >
            <i
              v-if="confirmModalConfirmIcon"
              :class="confirmModalConfirmIcon"
              aria-hidden="true"
            ></i>
            {{ confirmModalConfirmLabel }}
          </button>
        </div>
      </div>

      <!-- MODAL AGGIUNGI CLIENTE -->
      <div v-if="showAddModal" class="modal">
        <div class="modal-client">
          <h3>Aggiungi Cliente</h3>

          <div class="client-form-grid">
            <div class="form-field codfisc-field">
              <label for="newCodFisc">Codice Fiscale</label>
              <input
                id="newCodFisc"
                type="text"
                v-model="newCodFisc"
                placeholder="Codice Fiscale"
              />
            </div>

            <div class="form-field nome-field">
              <label for="newNome">Denominazione Cliente / Rag. Sociale</label>
              <input
                id="newNome"
                type="text"
                v-model="newNome"
                placeholder="Denominazione Cliente / Rag. Sociale"
              />
            </div>
          </div>

          <div class="file-import-section">
            <p class="file-note">
              Carica uno o entrambi i file richiesti (puoi farlo anche in
              seguito)
            </p>

            <div class="file-upload-card">
              <label class="file-label">Piano dei Conti</label>
              <div class="file-card-actions">
                <div class="file-input-wrapper">
                  <input
                    type="file"
                    ref="newFileInput"
                    accept=".xlsx,.xls,.csv"
                    @change="handlePianoInput"
                    id="piano-upload"
                  />
                  <label for="piano-upload" class="file-input-label">
                    <i class="fas fa-file-excel"></i>
                    Scegli file
                  </label>
                </div>
                <button
                  type="button"
                  class="model-download-btn"
                  @click="scaricaModelloBilancio('piano')"
                >
                  <i class="fas fa-download"></i>
                  Modello vuoto
                </button>
              </div>
              <button
                v-if="ExcelRows.length"
                @click="showExcelModal = true"
                class="btn-preview"
              >
                <i class="fas fa-eye"></i> Anteprima
              </button>
            </div>

            <div class="file-upload-card">
              <label class="file-label">Archivio Clienti e Fornitori</label>
              <div class="file-card-actions">
                <div class="file-input-wrapper">
                  <input
                    type="file"
                    ref="newAnagraficaInput"
                    accept=".xlsx,.xls,.csv"
                    @change="handleAnagraficaInput"
                    id="anagrafica-upload"
                  />
                  <label for="anagrafica-upload" class="file-input-label">
                    <i class="fas fa-file-excel"></i>
                    Scegli file
                  </label>
                </div>
                <button
                  type="button"
                  class="model-download-btn"
                  @click="scaricaModelloBilancio('anagrafica')"
                >
                  <i class="fas fa-download"></i>
                  Modello vuoto
                </button>
              </div>
              <button
                v-if="ExcelRowsAnagrafica.length"
                @click="showAnagraficaExcelModal = true"
                class="btn-preview"
              >
                <i class="fas fa-eye"></i> Anteprima
              </button>
            </div>
          </div>

          <div class="button-row">
            <button @click="addClient" class="btn-modal btn-primary">
              Aggiungi Cliente
            </button>
            <button @click="cancelAddClient" class="btn-modal btn-secondary">
              Annulla
            </button>
          </div>

          <div v-if="warningmsg" class="warning-message">
            {{ warningmsg }}
          </div>
        </div>
      </div>

      <!-- Modal anteprima Piano (invariato) -->
      <ExcelViewer
        v-if="showExcelModal"
        :rows="ExcelRows"
        :visible="showExcelModal"
        :title="fileTitle"
        @close="closeExcelModal"
      />

      <!-- Nuovo modal anteprima Anagrafica -->
      <ExcelViewer
        v-if="showAnagraficaExcelModal"
        :rows="ExcelRowsAnagrafica"
        :visible="showAnagraficaExcelModal"
        :title="fileTitleAnagrafica"
        @close="closeAnagraficaExcelModal"
      />

      <!-- MODAL AGGIUNGI FILE A UN CLIENTE ESISTENTE -->
      <UploadFileModal
        :visible="showClientFileUploadModal"
        :title="clientFileUploadTitle"
        :icon-class="clientFileUploadIconClass"
        input-id="bilancioClientFileUpload"
        :file-label="`Seleziona ${clientFileUploadTypeLabel}`"
        accept=".xlsx,.csv"
        submit-label="Carica e salva"
        :uploading="uploading"
        :error-message="clientFileUploadError"
        :show-preview="clientFileUploadRows.length > 0"
        preview-label="Visualizza Excel"
        @file-selected="handleClientFileSelected"
        @preview="showClientFilePreview = true"
        @submit="submitClientFileUpload"
        @close="closeClientFileUploadModal"
      >
        <template #extra-fields>
          <div class="client-file-upload-context">
            <div class="client-file-upload-context-row">
              <span>Cliente selezionato</span>
              <strong>{{ selectedClienteForAdd }}</strong>
            </div>
            <div class="client-file-upload-context-row">
              <span>Tipo di file</span>
              <strong>{{ clientFileUploadTypeLabel }}</strong>
            </div>
          </div>
        </template>
      </UploadFileModal>

      <ExcelViewer
        v-if="showClientFilePreview"
        :rows="clientFileUploadRows"
        :visible="showClientFilePreview"
        :title="clientFileUploadPreviewTitle"
        @close="showClientFilePreview = false"
      />

      <!-- MODAL RINOMINA -->
      <div v-if="showRenameModal" class="modal">
        <div class="modal-content rinomina-div">
          <h3>Rinomina Cliente</h3>
          <input type="text" v-model="newName" :placeholder="oldName" />
          <div class="button-group">
            <button @click="renameClientConfirm" class="btn-modal btn-primary">
              Rinomina
            </button>
            <button
              @click="showRenameModal = false"
              class="btn-modal btn-secondary"
            >
              Annulla
            </button>
          </div>
        </div>
      </div>

      <!-- SKELETON -->
      <div class="skeleton-loader" v-if="!isDataLoaded">
        <div class="skeleton skeleton-title"></div>
        <div class="skeleton skeleton-text"></div>
        <div class="skeleton skeleton-button"></div>
      </div>

      <!-- MODALI GLOBALI -->
      <SuccessMessage
        :message="successModalMessaggio"
        :isVisible="successModalVisibile"
        @close="onSuccessModalClosed"
      />
      <SimpleErrorModal
        :message="erroreModalMessaggio"
        :isVisible="erroreModalVisibile"
        @close="erroreModalVisibile = false"
      />
      <SalvaModifiche
        :isVisible="showSaveModal"
        :message="'Hai modifiche non salvate. Vuoi salvarle prima di uscire?'"
        @save="handleSaveBeforeLeave"
        @close="cancelLeave"
        @discard="discardChangesAndLeave"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import { haFunzionalita as ha } from "@/utils/plans.js";
import { API_BASE_URL } from "@/config.js";
import { downloadModello } from "@/utils/downloads.js";
import { validFiscalCode } from "@/utils/fiscalCode.js";
import {
  BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX,
  formatBilancioTeamSystemAccountCode,
} from "@/utils/bilancioAnaliticoCodes.js";
import SuccessMessage from "../components/SuccessMessage.vue";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import SalvaModifiche from "../components/SalvaModifiche.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import UploadFileModal from "@/components/UploadFileModal.vue";
import LibraryDeleteModal from "@/components/LibraryDeleteModal.vue";
import LibraryIcon from "@/components/LibraryIcon.vue";

export default {
  components: {
    SuccessMessage,
    SimpleErrorModal,
    SalvaModifiche,
    ExcelViewer,
    UploadFileModal,
    LibraryDeleteModal,
    LibraryIcon,
  },
  data() {
    return {
      studioUtente: "",
      clientiFiles: {}, // { cliente: [file1, file2, ...] }
      clientiLabels: {},
      openFolders: [], // Array di clienti aperti
      selectedCliente: null,
      selectedFile: null,
      selectedFileType: "", // 'piano' o 'anagrafica'
      jsonData: [], // Reset dati
      headers: [], // Table headers
      tableKey: 0,
      isSelectorCollapsed: false, // Controls collapse state of file selector
      isRowLayout: false, // Controls row vs column layout
      isDataLoaded: false,
      lastSavedData: [],
      isEditing: false,
      hasUnsavedChanges: false,
      modifiedCells: {},
      errors: {},
      provisionalRows: [],
      deletedRows: {},
      pendingDeletedRowCount: 0,
      activeDelete: {},
      hoveredRow: null,
      noChangesMessage: false,
      lastModified: "",
      successModalVisibile: false,
      successModalMessaggio: "",
      showErrorModal: false,
      erroreModalVisibile: false,
      erroreModalMessaggio: "",
      tooltip: {
        visible: false,
        rowIndex: null,
        content: "",
      },
      messageToShow: null,
      confirmModalVisibile: false,
      confirmModaltitle: "",
      confirmModalMessaggio: "",
      confirmModalConfirmLabel: "Elimina",
      confirmModalCancelLabel: "Annulla",
      confirmModalConfirmClass: "btn-danger",
      confirmModalConfirmIcon: "",
      nextRoute: null,
      showSaveModal: false,
      uploading: false,
      showAddModal: false,
      newCodFisc: "",
      newNome: "",
      showRenameModal: false,
      newName: "",
      oldName: "",
      showMenu: false,
      menuClient: null,
      ExcelRows: [],
      showExcelModal: false, // Controlla la visibilità del modal ExcelViewer
      pianoFile: null, // File selezionato per il caricamento
      fileTitle: "Nessun file selezionato", // Titolo del file
      anagraficaFile: null,
      ExcelRowsAnagrafica: [],
      showAnagraficaExcelModal: false,
      fileTitleAnagrafica: "Nessun file selezionato",
      fileType: "", // Tipo di file (csv o excel)
      warningmsg: "", // Messaggio di warning
      selectedClienteForAdd: null,
      showClientFileUploadModal: false,
      clientFileUploadType: "",
      clientFileUploadFile: null,
      clientFileUploadRows: [],
      clientFileUploadError: "",
      showClientFilePreview: false,
      menuX: 0,
      menuY: 0,
    };
  },
  mounted() {
    this.fetchClientiFiles();
    this.fetchConversionCount();
    this.headers = this.jsonData[0] || [];
    this.lastModified = new Date().toLocaleString();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      this.showSaveModal = true;
      this.nextRoute = next;
    } else {
      next();
    }
  },
  computed: {
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    isLibraryEmpty() {
      return Object.keys(this.clientiFiles || {}).length === 0;
    },
    fileTypeTitle() {
      return this.selectedFileType === "piano"
        ? "Piano dei Conti"
        : "Archivio Clienti e Fornitori";
    },
    clientFileUploadTypeLabel() {
      return this.clientFileUploadType === "piano"
        ? "Piano dei Conti"
        : "Archivio Clienti e Fornitori";
    },
    clientFileUploadTitle() {
      return `Aggiungi ${this.clientFileUploadTypeLabel}`;
    },
    clientFileUploadIconClass() {
      return this.clientFileUploadType === "piano"
        ? "fa-solid fa-table-list"
        : "fa-solid fa-address-book";
    },
    clientFileUploadPreviewTitle() {
      return this.clientFileUploadFile?.name || this.clientFileUploadTypeLabel;
    },
    visibleColumns() {
      if (!this.jsonData || this.jsonData.length < 1) return [];

      const headers = this.jsonData[0] || [];
      const numCols = headers.length;

      // Array di booleani: true = colonna visibile, false = colonna da nascondere
      const visibility = new Array(numCols).fill(true);

      // Per ogni colonna controlliamo se è vuota in TUTTE le righe dati (escludendo header)
      for (let col = 0; col < numCols; col++) {
        let isEmpty = true;

        for (let row = 1; row < this.jsonData.length; row++) {
          // partiamo da 1 per saltare header
          const cellValue = this.jsonData[row][col];
          if (
            cellValue !== "" &&
            cellValue !== null &&
            cellValue !== undefined
          ) {
            isEmpty = false;
            break;
          }
        }

        visibility[col] = !isEmpty;
      }

      return visibility;
    },

    // Opzionale: conteggio colonne visibili (per debug o layout)
    visibleColumnCount() {
      return this.visibleColumns.filter((v) => v).length;
    },
  },
  methods: {
    ha,
    displayBilancioFileName(file) {
      const displayNames = {
        "Bilancio Analitico - Piano dei Conti.xlsx": "Piano dei Conti.xlsx",
        "Bilancio Analitico - Archivio Clienti e Fornitori.xlsx":
          "Archivio Clienti e Fornitori.xlsx",
      };
      return displayNames[file] || file;
    },
    clientLabel(cliente) {
      return this.clientiLabels?.[cliente] || cliente || "";
    },
    hasPiano(files) {
      return files.some(
        (file) => file === "Bilancio Analitico - Piano dei Conti.xlsx"
      );
    },
    hasAnagrafica(files) {
      return files.some(
        (file) =>
          file === "Bilancio Analitico - Archivio Clienti e Fornitori.xlsx"
      );
    },
    fetchConversionCount() {
      axios
        .get(`${API_BASE_URL}/get_conversion_count`)
        .then((response) => {
          this.studioUtente = response.data.nome_studio;
          console.log(this.creditiRimanenti);
        })
        .catch((error) => {
          console.error("Errore nel recupero del contatore:", error);
        });
    },
    fetchClientiFiles() {
      axios
        .get(`${API_BASE_URL}/get_bilanci_analitici`)
        .then((response) => {
          this.clientiFiles = response.data.clienti_files;
          this.clientiLabels = response.data.clienti_labels || {};
        })
        .catch((error) => {
          console.error("Errore nel caricamento della lista clienti:", error);
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },
    getCodiceFiscale(cliente) {
      if (!cliente) return "";
      return cliente.split(" - ")[0];
    },
    toggleFolder(cliente) {
      const index = this.openFolders.indexOf(cliente);
      if (index === -1) {
        this.openFolders.push(cliente);
      } else {
        this.openFolders.splice(index, 1);
      }
    },
    isFolderOpen(cliente) {
      return this.openFolders.includes(cliente);
    },
    selectFile(cliente, file) {
      this.selectedCliente = cliente;
      this.selectedFile = file;
      this.selectedFileType =
        file === "Bilancio Analitico - Piano dei Conti.xlsx"
          ? "piano"
          : "anagrafica";
      this.jsonData = [];
      this.fetchFileContent(cliente, file);
    },
    fetchFileContent(cliente, file) {
      const filePath = `clienti/${cliente}/${file}`;
      const extension = file.split(".").pop().toLowerCase();

      axios
        .get(`${API_BASE_URL}/get_file?path=${encodeURIComponent(filePath)}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const data = new Uint8Array(response.data);
          if (extension === "csv") {
            const text = new TextDecoder().decode(data);
            const rows = text.split("\n").map((row) => row.split(","));
            this.jsonData = rows.filter((row) =>
              row.some((cell) => cell.trim() !== "")
            );
          } else if (extension === "xlsx") {
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            this.jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          }

          // Padding colonne e pulizia ultima colonna vuota
          const maxColumns = Math.max(
            ...this.jsonData.map((row) => row.length)
          );
          this.jsonData.forEach((row) => {
            while (row.length < maxColumns) row.push("");
          });

          const lastColumnIndex = this.jsonData[0].length - 1;
          const isLastColumnEmpty = this.jsonData.every(
            (row) => row[lastColumnIndex] === ""
          );
          if (isLastColumnEmpty) {
            this.jsonData.forEach((row) => row.pop());
          }

          this.headers = this.jsonData[0] || [];
          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.tableKey += 1;
          this.lastModified = new Date().toLocaleString();
          this.rebuildCellStates();
          this.hasUnsavedChanges = false;
          this.pendingDeletedRowCount = 0;
        })
        .catch((error) => {
          console.error("Errore nel caricamento del file:", error);
          this.jsonData = [];

          let msg = "Errore durante il caricamento del file.";

          if (error.response) {
            if (error.response.status === 404) {
              msg = "File non trovato.";
            } else if (error.response.status === 403) {
              msg = "Accesso non autorizzato.";
            } else if (error.response.status === 500) {
              msg = error.response.data?.error || "Errore interno del server.";
            } else {
              msg = error.response.data?.error || "Errore del server.";
            }
          }

          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        });
    },
    closePDC() {
      this.jsonData = [];
      this.selectedFile = null;
      this.selectedFileType = "";
    },
    toggleSelector() {
      this.isSelectorCollapsed = !this.isSelectorCollapsed;
    },
    toggleLayout() {
      this.isRowLayout = !this.isRowLayout;
    },
    downloadFile() {
      if (!this.selectedCliente || !this.selectedFile) return;

      const filePath = `clienti/${this.selectedCliente}/${this.selectedFile}`;

      axios
        .get(`${API_BASE_URL}/get_file?path=${encodeURIComponent(filePath)}`, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.selectedFile);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Errore nel download del file:", error);
          this.erroreModalMessaggio = "Errore durante il download del file.";
          this.erroreModalVisibile = true;
        });
    },
    async scaricaModelloFileSelezionato() {
      await this.scaricaModelloBilancio(this.selectedFileType);
    },
    async scaricaModelloBilancio(tipoFile) {
      const modello =
        tipoFile === "piano"
          ? {
              tipo: "bilancio_pdc",
              nome: "MODELLO - Bilancio Analitico - Piano dei Conti.xlsx",
            }
          : {
              tipo: "bilancio_acf",
              nome: "MODELLO - Bilancio Analitico - Archivio Clienti e Fornitori.xlsx",
            };

      try {
        await downloadModello(modello.tipo, modello.nome);
        this.successModalMessaggio = "Modello scaricato con successo!";
        this.successModalVisibile = true;
      } catch (err) {
        console.error("Errore download modello bilancio analitico:", err);
        this.erroreModalMessaggio =
          err.response?.data?.error ||
          "Errore durante il download del modello.";
        this.erroreModalVisibile = true;
      }
    },
    triggerFileReplace() {
      if (!this.selectedFile) return;
      this.$refs.fileInput.click();
    },
    replaceFile() {
      const file = this.$refs.fileInput.files[0];
      if (!file || !this.selectedCliente || !this.selectedFile) {
        this.erroreModalMessaggio = "Seleziona un file valido";
        this.erroreModalVisibile = true;
        return;
      }

      // Validazione estensione (come addPianoFile)
      const ext = file.name.split(".").pop().toLowerCase();
      if (!["xlsx", "csv"].includes(ext)) {
        this.erroreModalMessaggio = "Formato non supportato. Usa .xlsx o .csv";
        this.erroreModalVisibile = true;
        return;
      }

      this.uploading = true;
      document.documentElement.style.cursor = "progress";

      const filePath = `clienti/${this.selectedCliente}/${this.selectedFile}`;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", filePath);

      axios
        .post(`${API_BASE_URL}/replace_file`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((r) => {
          if (r.data.success) {
            this.successModalMessaggio = "File sostituito con successo!";
            this.successModalVisibile = true;
            this.fetchFileContent(this.selectedCliente, this.selectedFile);
          } else {
            this.erroreModalMessaggio = r.data.error || "Errore dal server";
            this.erroreModalVisibile = true;
          }
        })
        .catch((error) => {
          const msg = error.response?.data?.error || "Errore di rete";
          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          this.$refs.fileInput.value = "";
          document.documentElement.style.cursor = "default";
          this.uploading = false;
        });
    },
    deleteFile(event) {
      if (!this.selectedCliente || !this.selectedFile) return;
      // Mostra il modal di conferma
      const displayFileName = this.displayBilancioFileName(this.selectedFile);
      this.confirmModaltitle = "Elimina file dalla libreria";
      this.confirmModalMessaggio = `Stai eliminando "${displayFileName}" di "${this.selectedCliente}".\nI dati presenti nel file verranno rimossi in modo permanente.`;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      // Callback da eseguire dopo la risposta del modal
      this.confirmModalCallback = (confirmed) => {
        if (confirmed) {
          // Imposta cursore di attesa
          document.documentElement.style.cursor = "progress";
          document.body.style.cursor = "progress";
          if (event?.target) event.target.style.cursor = "progress";

          const filePath = `clienti/${this.selectedCliente}/${this.selectedFile}`;

          axios
            .delete(
              `${API_BASE_URL}/delete_file?path=${encodeURIComponent(filePath)}`
            )
            .then(() => {
              // Messaggio di successo con modal
              this.successModalMessaggio = `Il file "${displayFileName}" è stato eliminato con successo.`;
              this.successModalVisibile = true;

              // Ripristina stato
              this.selectedCliente = null;
              this.selectedFile = null;
              this.selectedFileType = "";
              this.jsonData = [];
              this.pendingDeletedRowCount = 0;

              // Aggiorna lista file
              this.fetchClientiFiles();
            })
            .catch((error) => {
              console.error("Errore nell'eliminazione del file:", error);
              const msg = error.response?.data?.error
                ? `Errore durante l'eliminazione: ${error.response.data.error}`
                : "Errore durante l'eliminazione del file.";

              this.erroreModalMessaggio = msg;
              this.erroreModalVisibile = true;
            })
            .finally(() => {
              // Ripristina il cursore
              document.documentElement.style.cursor = "default";
              document.body.style.cursor = "default";
              if (event?.target) event.target.style.cursor = "pointer";
            });
        }

        // Chiudi sempre il modal
        this.confirmModalVisibile = false;
        this.confirmModaltitle = "";
        this.confirmModalMessaggio = "";
        this.confirmModalConfirmLabel = "Elimina";
        this.confirmModalCancelLabel = "Annulla";
        this.confirmModalConfirmClass = "btn-danger";
        this.confirmModalConfirmIcon = "";
        this.confirmModalCallback = null;
      };
    },

    toggleEditing() {
      this.isEditing = !this.isEditing;
    },
    handlePianoInput(event) {
      const newFile = event.target.files[0];

      // Gestione della cancellazione (utente annulla la selezione)
      if (!newFile) {
        this.pianoFile = null;
        this.fileTitle = "Nessun file selezionato";
        this.ExcelRows = [];
        this.showExcelModal = false;
        this.fileType = "";
        return;
      }

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Validazione del tipo di file
      if (!["csv", "xlsx", "xls"].includes(estensione)) {
        this.warningmsg = "Formato file non supportato. Usa CSV o Excel.";
        this.$refs.newFileInput.value = "";
        setTimeout(() => {
          this.warningmsg = "";
        }, 3000);
        return;
      }

      // Aggiorna le proprietà
      this.pianoFile = newFile;
      this.fileTitle = filename;
      this.fileType = estensione === "csv" ? "csv" : "excel";
      this.leggiFileExcelOCsv(newFile, estensione);
    },
    handleAnagraficaInput(event) {
      const file = event.target.files[0];
      if (!file) {
        this.anagraficaFile = null;
        this.ExcelRowsAnagrafica = [];
        this.fileTitleAnagrafica = "Nessun file selezionato";
        return;
      }

      const estensione = file.name.split(".").pop().toLowerCase();
      if (!["xlsx", "xls", "csv"].includes(estensione)) {
        this.warningmsg = "Formato non supportato. Usa .xlsx, .xls o .csv";
        this.$refs.newAnagraficaInput.value = "";
        setTimeout(() => (this.warningmsg = ""), 3000);
        return;
      }

      this.anagraficaFile = file;
      this.fileTitleAnagrafica = file.name;
      this.leggiFileExcelOCsv(file, estensione, "anagrafica"); // vedi sotto
    },
    leggiFileExcelOCsv(file, estensione, tipo = "piano") {
      try {
        const reader = new FileReader();

        reader.onload = (e) => {
          let rows = [];
          if (estensione === "csv") {
            const testoCsv = e.target.result;
            rows = testoCsv
              .split("\n")
              .map((line) => line.split(",").map((cell) => cell.trim()))
              .filter((row) => row.some((cell) => cell !== ""));
          } else {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          }

          if (tipo === "piano") {
            this.ExcelRows = rows;
          } else if (tipo === "anagrafica") {
            this.ExcelRowsAnagrafica = rows;
          } else if (tipo === "client-upload") {
            this.clientFileUploadRows = rows;
          }
        };

        if (estensione === "csv") {
          reader.readAsText(file);
        } else {
          reader.readAsArrayBuffer(file);
        }
      } catch (error) {
        console.error("Errore lettura file anteprima:", error);
        this.warningmsg = "Errore nella lettura del file per anteprima";
        setTimeout(() => (this.warningmsg = ""), 3000);
      }
    },

    // Chiudi modal anteprime
    closeExcelModal() {
      this.showExcelModal = false;
    },

    closeAnagraficaExcelModal() {
      this.showAnagraficaExcelModal = false;
    },
    isEditableColumntable(colIndex) {
      if (this.selectedFileType === "piano") {
        return colIndex !== 0;
      } else {
        // Per anagrafica, assumiamo tutte editabili; modifica se necessario
        return true;
      }
    },
    isCellModified(rowIndex, colIndex) {
      return !!this.modifiedCells[`${rowIndex}-${colIndex}`];
    },
    showTooltip(rowIndex, colIndex, row) {
      this.tooltip.visible = true;
      this.tooltip.rowIndex = rowIndex;
      this.tooltip.content = row[0];
    },
    saveChanges(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      if (Object.keys(this.errors).length > 0) {
        this.erroreModalMessaggio =
          "Correggi gli errori evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return;
      }
      if (!skipDeletionConfirmation && this.pendingDeletedRowCount > 0) {
        this.confirmSaveWithPendingDeletions(this.pendingDeletedRowCount, () =>
          this.saveChanges(event, true)
        );
        return;
      }
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event && event.target) {
        event.target.style.cursor = "progress";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.jsonData);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const excelBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const formData = new FormData();
      formData.append("file", excelBlob, "lba_modificato.xlsx");
      formData.append("cliente", this.selectedCliente); // Add cliente to FormData
      formData.append("filename", this.selectedFile); // Add filename to FormData
      axios
        .post(`${API_BASE_URL}/update_PBA`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.successModalMessaggio = "Modifiche salvate con successo!";
          this.successModalVisibile = true;
          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.modifiedCells = {};
          this.errors = {};
          this.finalizeAllRows();
          this.pendingDeletedRowCount = 0;
          this.messageToShow = "dataLoaded";
          return this.fetchFileContent(this.selectedCliente, this.selectedFile);
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file:", error);
          const msg = error.response?.data?.error
            ? `Errore nel salvataggio: ${error.response.data.error}`
            : "Errore nel salvataggio del file.";

          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
          this.messageToShow = null;
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event && event.target) {
            event.target.style.cursor = "pointer";
          }
          this.hasUnsavedChanges = false;
          this.refreshDashboard();
        });
    },
    cancelChanges() {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      this.jsonData = JSON.parse(JSON.stringify(this.lastSavedData));
      this.tableKey++;
      this.hasUnsavedChanges = false;
      this.errors = {};
      this.modifiedCells = {};
      this.provisionalRows = [];
      this.pendingDeletedRowCount = 0;
      this.finalizeAllRows();
      this.rebuildCellStates();
      this.refreshDashboard();
    },
    resetConfirmModal() {
      this.confirmModalVisibile = false;
      this.confirmModaltitle = "";
      this.confirmModalMessaggio = "";
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalCallback = null;
    },
    confirmSaveWithPendingDeletions(count, onConfirm) {
      this.confirmModaltitle = "Salva modifiche";
      this.confirmModalMessaggio =
        count === 1
          ? "Tra le modifiche correnti e' inclusa anche l'eliminazione di 1 riga. Con il salvataggio verranno eliminati i dati della riga rimossa dal file selezionato."
          : `Tra le modifiche correnti sono incluse anche ${count} eliminazioni di riga. Con il salvataggio verranno eliminati i dati delle righe rimosse dal file selezionato.`;
      this.confirmModalConfirmLabel = "Salva";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-primary";
      this.confirmModalConfirmIcon = "fa-solid fa-floppy-disk";
      this.confirmModalVisibile = true;
      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();
        if (confirmed) onConfirm();
      };
    },
    handleSaveBeforeLeave() {
      const fakeEvent = { target: { style: { cursor: "pointer" } } };
      this.saveChanges(fakeEvent);
      this.showSaveModal = false;
      this.pendingNavigationAfterSuccess = true; // aspetta la chiusura del SuccessMessage
    },
    cancelLeave() {
      this.showSaveModal = false;
      this.nextRoute = null;
    },
    discardChangesAndLeave() {
      this.cancelChanges(); // annulla le modifiche
      this.showSaveModal = false;
      if (this.nextRoute) {
        this.nextRoute(); // continua la navigazione
        this.nextRoute = null;
      }
    },
    onSuccessModalClosed() {
      this.successModalVisibile = false;

      // Se stavi uscendo dalla pagina, ora puoi navigare
      if (this.pendingNavigationAfterSuccess && this.nextRoute) {
        this.nextRoute(); // naviga
        this.pendingNavigationAfterSuccess = false;
        this.nextRoute = null;
      }
    },
    finalizeAllRows() {
      this.provisionalRows = [];
    },
    rebuildCellStates() {
      const newModified = {};
      const newErrors = {};

      const numRows = Math.min(this.jsonData.length, this.lastSavedData.length);
      const numCols = this.headers.length;

      for (let rowIndex = 0; rowIndex < numRows; rowIndex++) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          const current = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          const original = this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";

          // SE È DIVERSA → è modificata
          if (String(current) !== String(original)) {
            newModified[key] = true;

            // VALIDAZIONE ERRORI: SOLO QUI, SOLO SE MODIFICATA!
            if (this.selectedFileType === "piano") {
              const columnName = this.headers[colIndex];
              const numericValue = String(current).replace(/\D/g, "");

              if (columnName === "Cod. Conto - TeamSystem") {
                if (
                  current &&
                  !BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(current)
                ) {
                  newErrors[key] = true;
                }
              }
              // Datev
              else if (
                (colIndex === 2 || columnName.includes("Datev")) &&
                numericValue.length > 0 &&
                (numericValue.length < 5 || numericValue.length > 11)
              ) {
                newErrors[key] = true;
              }
              // Zucchetti (col=4)
              else if (
                colIndex === 4 &&
                numericValue.length > 0 &&
                (numericValue.length < 6 || numericValue.length > 8)
              ) {
                newErrors[key] = true;
              }
              // SEAC (col=5)
              else if (
                colIndex === 5 &&
                numericValue.length > 0 &&
                numericValue.length !== 6
              ) {
                newErrors[key] = true;
              }
              // Sistemi (col=6)
              else if (colIndex === 6) {
                const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;
                if (current && !sistemiRegex.test(current)) {
                  newErrors[key] = true;
                }
              }
            }
            // Per anagrafica: no errori specifici, o aggiungi qui regole diverse se noto
          }
          // SE È UGUALE → SALTA TUTTO: NIENTE ERRORI
        }
      }

      // Righe aggiunte: segna come modificate + valida
      for (
        let rowIndex = numRows;
        rowIndex < this.jsonData.length;
        rowIndex++
      ) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          newModified[key] = true;

          if (this.selectedFileType === "piano") {
            const current = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
            const numericValue = String(current).replace(/\D/g, "");

            if (this.headers[colIndex] === "Cod. Conto - TeamSystem") {
              if (current && !BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(current))
                newErrors[key] = true;
            } else if (
              (colIndex === 2 || this.headers[colIndex].includes("Datev")) &&
              numericValue.length > 0 &&
              (numericValue.length < 5 || numericValue.length > 11)
            ) {
              newErrors[key] = true;
            } else if (
              colIndex === 4 &&
              numericValue.length > 0 &&
              (numericValue.length < 6 || numericValue.length > 8)
            ) {
              newErrors[key] = true;
            } else if (
              colIndex === 5 &&
              numericValue.length > 0 &&
              numericValue.length !== 6
            ) {
              newErrors[key] = true;
            } else if (colIndex === 6) {
              const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;
              if (current && !sistemiRegex.test(current)) newErrors[key] = true;
            }
          }
          // Per anagrafica: no errori, o aggiungi regole
        }
      }

      this.modifiedCells = newModified;
      this.errors = newErrors;
    },
    updateCell(rowIndex, colIndex, value) {
      const table = document.getElementById("excelTable");
      const cell = table?.rows[rowIndex]?.cells[colIndex + 1];
      if (!cell) return;

      if (this.selectedFileType === "piano") {
        // --- LOGICA "N.A." universale (esclusa la colonna Descrizione Cod. Conto) ---
        const previousValue = this.jsonData[rowIndex][colIndex] || "";
        const isEmptyOrNA =
          previousValue.trim() === "" ||
          previousValue.trim().toUpperCase() === "N.A.";
        const hasLetters = /[a-zA-Z]/.test(value);
        const hasNumbers = /\d/.test(value);

        if (isEmptyOrNA && hasLetters && !hasNumbers) {
          this.jsonData[rowIndex][colIndex] = "N.A.";
          cell.innerText = "N.A.";

          this.$delete(this.errors, `${rowIndex}-${colIndex}`);

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== "N.A.") {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );

          this.$forceUpdate();
          return;
        }

        if (colIndex === 1) {
          const key = `${rowIndex}-${colIndex}`;
          this.jsonData[rowIndex][colIndex] = value;
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(value) !== String(originalValue)) {
            this.$set(this.modifiedCells, key, true);
          } else {
            this.$delete(this.modifiedCells, key);
          }
          this.$delete(this.errors, key);
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          return;
        }

        // TeamSystem
        if (this.headers[colIndex] === "Cod. Conto - TeamSystem") {
          const formattedValue = formatBilancioTeamSystemAccountCode(value);
          const selection = window.getSelection();
          let cursorPosition = selection?.anchorOffset || 0;
          const oldSeparatorCount = (value.match(/\//g) || []).length;

          const newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          cursorPosition += newSeparatorCount - oldSeparatorCount;

          const isValid =
            formattedValue === "" ||
            BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(formattedValue);

          this.$nextTick(() => {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }

            this.jsonData[rowIndex][colIndex] = formattedValue || "";

            const originalValue =
              this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
            if (
              String(originalValue) !==
              String(this.jsonData[rowIndex][colIndex])
            ) {
              this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
            }

            this.hasUnsavedChanges = !this.isDataEqual(
              this.jsonData,
              this.lastSavedData
            );
          });
          return;
        }

        // Datev, Zucchetti, SEAC
        if (colIndex === 3 || colIndex === 5 || colIndex === 6) {
          const selection = window.getSelection();
          let cursorPosition = selection?.anchorOffset || 0;
          let formattedValue = value.replace(/\D/g, "");
          let isValid = true;

          if (colIndex === 3) {
            // Datev
            formattedValue = formattedValue.slice(0, 11);
            isValid =
              formattedValue.length === 0 ||
              (formattedValue.length >= 5 && formattedValue.length <= 11);
          } else if (colIndex === 5) {
            // Zucchetti
            isValid = true;
          } else if (colIndex === 6) {
            // SEAC
            formattedValue = formattedValue.slice(0, 6);
            isValid =
              formattedValue.length === 0 || formattedValue.length === 6;
          }

          this.$nextTick(() => {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }

            this.jsonData[rowIndex][colIndex] = formattedValue || "";

            const originalValue =
              this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
            if (
              String(originalValue) !==
              String(this.jsonData[rowIndex][colIndex])
            ) {
              this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
            }

            this.hasUnsavedChanges = !this.isDataEqual(
              this.jsonData,
              this.lastSavedData
            );
          });
          return;
        }

        // Sistemi (piano)
        if (colIndex === 7) {
          let formattedValue = value.replace(/\D/g, "");
          const selection = window.getSelection();
          let cursorPosition = selection?.anchorOffset || 0;
          const oldSeparatorCount = (value.match(/\./g) || []).length;

          formattedValue = formattedValue.slice(0, 9);
          if (formattedValue.length >= 7) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(
              4,
              6
            )}.${formattedValue.slice(6)}`;
          } else if (formattedValue.length >= 5) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(4)}`;
          } else if (formattedValue.length >= 3) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2)}`;
          }

          const newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          cursorPosition += newSeparatorCount - oldSeparatorCount;

          const isValid =
            formattedValue === "" ||
            /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(formattedValue);

          this.$nextTick(() => {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }

            this.jsonData[rowIndex][colIndex] = formattedValue || "";

            const originalValue =
              this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
            if (
              String(originalValue) !==
              String(this.jsonData[rowIndex][colIndex])
            ) {
              this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
            }

            this.hasUnsavedChanges = !this.isDataEqual(
              this.jsonData,
              this.lastSavedData
            );
          });
          return;
        }
      }

      // ────────────────────────────────────────────────
      //                  ANAGRAFICA
      // ────────────────────────────────────────────────

      if (this.selectedFileType === "anagrafica") {
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;

        // Codice Fiscale
        if (colIndex === 2) {
          const formattedValue = value.trim().toUpperCase();
          const isValid =
            formattedValue === "" || validFiscalCode(formattedValue);

          cell.innerText = formattedValue;
          if (!isValid) {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          this.jsonData[rowIndex][colIndex] = formattedValue;

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(formattedValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          return;
        }

        // TeamSystem
        if (this.headers[colIndex] === "Cod. Conto - TeamSystem") {
          const formattedValue = formatBilancioTeamSystemAccountCode(value);
          const oldSeparatorCount = (value.match(/\//g) || []).length;

          const newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          cursorPosition += newSeparatorCount - oldSeparatorCount;

          const isValid =
            formattedValue === "" ||
            BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(formattedValue);

          this.$nextTick(() => {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }

            this.jsonData[rowIndex][colIndex] = formattedValue || "";

            const originalValue =
              this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
            if (
              String(originalValue) !==
              String(this.jsonData[rowIndex][colIndex])
            ) {
              this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
            }

            this.hasUnsavedChanges = !this.isDataEqual(
              this.jsonData,
              this.lastSavedData
            );
          });
          return;
        }

        // Datev
        if (colIndex === 5) {
          let formattedValue = value.replace(/\D/g, "").slice(0, 11);
          const isValid =
            formattedValue.length === 0 ||
            (formattedValue.length >= 5 && formattedValue.length <= 11);

          cell.innerText = formattedValue;
          if (!isValid && formattedValue !== "") {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          this.jsonData[rowIndex][colIndex] = formattedValue;

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(formattedValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          return;
        }

        // Zucchetti
        if (colIndex === 7) {
          const formattedValue = value.replace(/\D/g, "");

          cell.innerText = formattedValue;
          this.$delete(this.errors, `${rowIndex}-${colIndex}`);

          this.jsonData[rowIndex][colIndex] = formattedValue;

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(formattedValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          return;
        }

        // SEAC
        if (colIndex === 9) {
          let formattedValue = value.replace(/\D/g, "").slice(0, 6);
          const isValid =
            formattedValue.length === 0 || formattedValue.length === 6;

          cell.innerText = formattedValue;
          if (!isValid && formattedValue !== "") {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          this.jsonData[rowIndex][colIndex] = formattedValue;

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(formattedValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          return;
        }

        // Sistemi (anagrafica)
        if (colIndex === 11) {
          let formattedValue = value.replace(/\D/g, "");
          const oldSeparatorCount = (value.match(/\./g) || []).length;

          formattedValue = formattedValue.slice(0, 9);
          if (formattedValue.length >= 7) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(
              4,
              6
            )}.${formattedValue.slice(6)}`;
          } else if (formattedValue.length >= 5) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(4)}`;
          } else if (formattedValue.length >= 3) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2)}`;
          }

          const newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          cursorPosition += newSeparatorCount - oldSeparatorCount;

          const isValid =
            formattedValue === "" ||
            /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(formattedValue);

          this.$nextTick(() => {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }

            this.jsonData[rowIndex][colIndex] = formattedValue || "";

            const originalValue =
              this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
            if (
              String(originalValue) !==
              String(this.jsonData[rowIndex][colIndex])
            ) {
              this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
            }

            this.hasUnsavedChanges = !this.isDataEqual(
              this.jsonData,
              this.lastSavedData
            );
          });
          return;
        }

        // ────────────────────────────────────────────────
        // DEFAULT: tutte le altre colonne dell'anagrafica
        // (denominazione, indirizzo, città, PEC, telefono, note, ecc...)
        // ────────────────────────────────────────────────
        const key = `${rowIndex}-${colIndex}`;
        const originalValue = this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";

        let finalValue = value; // NON trim qui, per non spostare il cursore inutilmente

        this.$nextTick(() => {
          // Salva la posizione attuale del cursore PRIMA di modificare innerText
          const sel = window.getSelection();
          let cursorPos = sel?.anchorOffset ?? finalValue.length;

          cell.innerText = finalValue;

          // Ripristina cursore
          if (cell.firstChild) {
            const range = document.createRange();
            // Se l'utente stava scrivendo alla fine → cursore alla fine
            if (cursorPos >= value.length) {
              cursorPos = finalValue.length;
            }
            range.setStart(
              cell.firstChild,
              Math.min(cursorPos, finalValue.length)
            );
            range.collapse(true);

            sel.removeAllRanges();
            sel.addRange(range);
          }

          this.jsonData[rowIndex][colIndex] = finalValue;

          if (String(finalValue) !== String(originalValue)) {
            this.$set(this.modifiedCells, key, true);
          } else {
            this.$delete(this.modifiedCells, key);
          }

          this.$delete(this.errors, key);

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });

        return;
      }
    },

    isDataEqual(data1, data2) {
      if (!data1 || !data2 || data1.length !== data2.length) return false;

      const stringifyData1 = JSON.stringify(
        data1.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      const stringifyData2 = JSON.stringify(
        data2.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      return stringifyData1 === stringifyData2;
    },
    deleteRow(rowIndex, event) {
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      event.target.style.cursor = "progress";
      this.deletedRows = { ...this.deletedRows, [rowIndex]: true };
      this.$set(this.activeDelete, rowIndex, true);
      const isProvisionalRow = this.provisionalRows.includes(rowIndex);
      if (!isProvisionalRow) {
        this.pendingDeletedRowCount += 1;
      }

      setTimeout(() => {
        this.jsonData.splice(rowIndex, 1);

        this.provisionalRows = this.provisionalRows
          .filter((i) => i !== rowIndex)
          .map((i) => (i > rowIndex ? i - 1 : i));

        const newModified = {};
        Object.keys(this.modifiedCells).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return;
          const newRow = r > rowIndex ? r - 1 : r;
          newModified[`${newRow}-${c}`] = this.modifiedCells[key];
        });
        this.modifiedCells = newModified;

        const newErrors = {};
        Object.keys(this.errors).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return;
          const newRow = r > rowIndex ? r - 1 : r;
          newErrors[`${newRow}-${c}`] = this.errors[key];
        });
        this.errors = newErrors;

        this.hoveredRow = null;
        this.$delete(this.deletedRows, rowIndex);
        this.$delete(this.activeDelete, rowIndex);

        this.tableKey++;
        this.hasUnsavedChanges = !this.isDataEqual(
          this.jsonData,
          this.lastSavedData
        );

        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        event.target.style.cursor = "pointer";
      }, 700);
    },
    refreshDashboard() {
      console.log("Refreshing dashboard...");
    },
    openAddModal() {
      this.newCodFisc = "";
      this.newNome = "";
      this.showAddModal = true;
    },
    triggerAddPiano(cliente) {
      this.openClientFileUploadModal(cliente, "piano");
    },
    triggerAddAnagrafica(cliente) {
      this.openClientFileUploadModal(cliente, "anagrafica");
    },
    openClientFileUploadModal(cliente, tipo) {
      this.selectedClienteForAdd = cliente;
      this.clientFileUploadType = tipo;
      this.clientFileUploadFile = null;
      this.clientFileUploadRows = [];
      this.clientFileUploadError = "";
      this.showClientFilePreview = false;
      this.showClientFileUploadModal = true;
    },
    closeClientFileUploadModal() {
      this.showClientFileUploadModal = false;
      this.showClientFilePreview = false;
      this.selectedClienteForAdd = null;
      this.clientFileUploadType = "";
      this.clientFileUploadFile = null;
      this.clientFileUploadRows = [];
      this.clientFileUploadError = "";
    },
    handleClientFileSelected(file) {
      this.clientFileUploadFile = file;
      this.clientFileUploadRows = [];
      this.clientFileUploadError = "";
      this.showClientFilePreview = false;
      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();
      if (!["xlsx", "csv"].includes(extension)) {
        this.clientFileUploadError =
          "Formato file non supportato. Usa .xlsx o .csv.";
        return;
      }

      this.leggiFileExcelOCsv(file, extension, "client-upload");
    },
    submitClientFileUpload({ file }) {
      const cliente = this.selectedClienteForAdd;
      const tipo = this.clientFileUploadType;
      if (!file || !cliente || !["piano", "anagrafica"].includes(tipo)) {
        this.clientFileUploadError = "Seleziona un file valido da caricare.";
        return;
      }

      const extension = file.name.split(".").pop().toLowerCase();
      if (!["xlsx", "csv"].includes(extension)) {
        this.clientFileUploadError =
          "Formato file non supportato. Usa .xlsx o .csv.";
        return;
      }

      const targetFile =
        tipo === "piano"
          ? "Bilancio Analitico - Piano dei Conti.xlsx"
          : "Bilancio Analitico - Archivio Clienti e Fornitori.xlsx";
      const filePath = `clienti/${cliente}/${targetFile}`;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", filePath);

      this.uploading = true;
      this.clientFileUploadError = "";
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";

      axios
        .post(`${API_BASE_URL}/replace_file`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status !== 200) {
            this.clientFileUploadError =
              response.data?.error || "Errore sconosciuto.";
            return;
          }

          this.showClientFileUploadModal = false;
          this.showClientFilePreview = false;
          if (!this.openFolders.includes(cliente))
            this.openFolders.push(cliente);
          this.fetchClientiFiles();
          this.selectFile(cliente, targetFile);
          this.successModalMessaggio =
            tipo === "piano"
              ? "Piano dei Conti aggiunto con successo!"
              : "Archivio Clienti e Fornitori aggiunto con successo!";
          this.successModalVisibile = true;
          this.selectedClienteForAdd = null;
          this.clientFileUploadFile = null;
          this.clientFileUploadRows = [];
        })
        .catch((error) => {
          console.error("Errore nell'aggiunta del file cliente:", error);
          this.clientFileUploadError =
            error.response?.data?.error || "Errore durante il caricamento.";
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          this.uploading = false;
        });
    },
    addClient() {
      if (!this.newCodFisc || !this.newNome) {
        this.warningmsg = "Inserisci Codice Fiscale e Nome Cliente.";
        setTimeout(() => (this.warningmsg = ""), 3000);
        return;
      }

      const codiceFiscale = this.newCodFisc.trim().toUpperCase();
      if (!validFiscalCode(codiceFiscale)) {
        this.warningmsg =
          "Il Codice Fiscale deve contenere 11 cifre oppure 16 caratteri alfanumerici.";
        setTimeout(() => (this.warningmsg = ""), 3000);
        return;
      }

      const formData = new FormData();
      formData.append("codfisc", codiceFiscale);
      formData.append("nome", this.newNome);

      // Aggiungiamo i file solo se presenti
      if (this.pianoFile) {
        formData.append("file", this.pianoFile); // come prima, per Piano
      }
      if (this.anagraficaFile) {
        formData.append("anagraficaFile", this.anagraficaFile);
      }

      axios
        .post(`${API_BASE_URL}/create_client`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.successModalMessaggio = "Cliente aggiunto con successo!";
          this.successModalVisibile = true;
          this.showAddModal = false;
          this.cancelAddClient(); // resetta tutto
          this.fetchClientiFiles();
        })
        .catch((error) => {
          console.error("Errore nell'aggiunta del cliente:", error);
          this.warningmsg =
            error.response?.data?.error || "Errore nell'aggiunta del cliente.";
          setTimeout(() => (this.warningmsg = ""), 5000);
        });
    },

    // Aggiorna cancelAddClient per resettare anche l'anagrafica
    cancelAddClient() {
      this.showExcelModal = false;
      this.showAnagraficaExcelModal = false;
      this.ExcelRows = [];
      this.ExcelRowsAnagrafica = [];
      this.pianoFile = null;
      this.anagraficaFile = null;
      this.fileTitle = "Nessun file selezionato";
      this.fileTitleAnagrafica = "Nessun file selezionato";
      this.$refs.newFileInput.value = "";
      if (this.$refs.newAnagraficaInput)
        this.$refs.newAnagraficaInput.value = "";
      this.warningmsg = "";
      this.showAddModal = false;
    },
    openMenu(cliente, event) {
      if (!cliente) return;

      if (this.showMenu && this.menuClient === cliente) {
        this.closeMenu();
        return;
      }

      this.menuClient = cliente;

      this.$nextTick(() => {
        const icon = event.target.closest(".fa-ellipsis");
        if (!icon) return;

        const rect = icon.getBoundingClientRect();
        let top = rect.bottom + 8;
        let left = rect.left;

        // Posizionamento intelligente
        if (left + 150 > window.innerWidth) {
          left = window.innerWidth - 158;
        }
        if (top + 100 > window.innerHeight) {
          top = rect.top - 108;
        }

        this.menuX = left;
        this.menuY = top;
        this.showMenu = true;
      });
    },

    closeMenu() {
      this.showMenu = false;
    },

    handleClickOutside(event) {
      const menu = this.$el.querySelector(".context-menu");
      const ellipsis = event.target.closest(".ellipsis-wrapper");
      const isInsideMenu = menu && menu.contains(event.target);
      const isInsideModal = event.target.closest(".modal");
      const isInsideContextMenuItem = event.target.closest(".context-menu li");

      // Se clicco su un elemento del menu, NON chiudere
      if (
        isInsideMenu ||
        isInsideContextMenuItem ||
        ellipsis ||
        isInsideModal
      ) {
        return;
      }

      this.closeMenu();

      // Chiudi editing tabella
      if (
        this.$refs.exceltableRef &&
        !this.$refs.exceltableRef.contains(event.target) &&
        this.$refs.dashboardRef &&
        !this.$refs.dashboardRef.contains(event.target)
      ) {
        this.isEditing = false;
      }
    },

    openRenameModal() {
      if (!this.menuClient) return;

      const parts = this.menuClient.split(" - ");
      this.oldName = parts.slice(1).join(" - ");
      this.newName = this.oldName;

      // Apri il modal e poi chiudi il menu
      this.showRenameModal = true;
      this.$nextTick(() => {
        this.closeMenu();
      });
    },

    openDeleteConfirm() {
      if (!this.menuClient) return;
      this.confirmModaltitle = "Elimina Cartella";
      this.confirmModalMessaggio = `Sei sicuro di voler eliminare la cartella del cliente "${this.clientLabel(
        this.menuClient
      )}"?`;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        if (confirmed) {
          axios
            .delete(
              `${API_BASE_URL}/delete_client?cliente=${encodeURIComponent(
                this.menuClient
              )}`
            )
            .then(() => {
              this.successModalMessaggio = "Cliente eliminato con successo!";
              this.successModalVisibile = true;
              if (this.selectedCliente === this.menuClient) this.closePDC();
              this.fetchClientiFiles();
            })
            .catch(() => alert("Errore nell'eliminazione."));
        }
        this.resetConfirmModal();
      };

      // Chiudi il menu DOPO aver aperto il modal
      this.$nextTick(() => {
        this.closeMenu();
      });
    },
    renameClientConfirm() {
      if (!this.newName) {
        alert("Inserisci il nuovo nome.");
        return;
      }
      const formData = new FormData();
      formData.append("old_cliente", this.menuClient);
      formData.append("new_name", this.newName);
      axios
        .post(`${API_BASE_URL}/rename_client`, formData)
        .then(() => {
          this.successModalMessaggio = "Cliente rinominato con successo!";
          this.successModalVisibile = true;
          this.showRenameModal = false;
          if (this.selectedCliente === this.menuClient) {
            this.closePDC();
          }
          this.fetchClientiFiles();
        })
        .catch((error) => {
          console.error("Errore nella rinominazione del cliente:", error);
          this.erroreModalMessaggio =
            error.response?.data?.error ||
            "Errore durante la rinominazione del cliente.";
          this.erroreModalVisibile = true;
        });
    },
  },
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.main-container h2 {
  margin-bottom: 17px;
  text-align: center;
}
.library-scope-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.35rem;
  padding: 0.32rem 0.6rem;
  border: 1px solid #eadbbd;
  border-radius: 999px;
  background: #fff7e7;
  color: #8a651d;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.library-scope-badge i {
  font-size: 0.68rem;
}
.italic-none {
  font-style: italic;
  font-size: 0.95rem;
  color: rgb(156, 156, 156);
}
.libreria-bilanci {
  position: relative;
  width: 80rem;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.selector-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: max-height 0.3s ease;
}

.selector-container.collapsed {
  max-height: 50px;
  overflow: hidden;
}
.tree-view,
.folder-item,
.folder-header,
.file-list {
  overflow: visible !important;
}
.selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 0.75rem;
}

.selector-header h3 {
  font-size: 18px;
  margin: 0;
  color: #444;
}
.add-button {
  background: none;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  padding: 8px 10px;
  margin-right: 2rem;
  transition: all 0.3s ease;
}
.add-button:hover {
  background: rgb(244, 244, 244);
}

.add-button i {
  font-size: 16px;
  color: #3498db;
  margin-right: 5px;
}

.selector-header .toolbar {
  display: flex;
  gap: 12px;
}
.espandi-button,
.layout-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.espandi-button i,
.layout-button i {
  font-size: 16px;
  color: #3498db;
}

.selector-content {
  position: relative; /* ← Contiene il menu absolute */
  overflow: visible !important;
  padding: 0px 15px 15px 15px;
  min-height: 7rem;
}

.selector-content--empty {
  min-height: 10.5rem;
  display: flex;
  align-items: center;
  padding: 1.35rem 1.65rem 1.5rem;
}

.empty-library-state {
  --empty-accent: #8d6a23;
  --empty-accent-strong: #5a4010;
  --empty-accent-hover: #5a4010;
  --empty-soft: rgba(141, 106, 35, 0.14);
  --empty-border: rgba(141, 106, 35, 0.24);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  max-width: 66rem;
}

.empty-library-icon {
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--empty-soft);
  color: var(--empty-accent-strong);
  font-size: 1.2rem;
}

.empty-library-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.48rem;
  min-width: 0;
  max-width: 60rem;
  text-align: left;
}

.empty-library-title {
  margin: 0;
  color: #2f2923;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
}

.empty-library-line {
  margin: 0;
  color: #5d6b79;
  font-size: 1rem;
  line-height: 1.42;
  text-align: left;
}

.empty-library-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-top: 0.3rem;
}

.empty-library-action {
  min-height: 2.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.52rem 0.85rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease, transform 0.18s ease;
}

.empty-library-action:hover {
  transform: translateY(-1px);
}

.empty-library-action--primary {
  border: 1px solid var(--empty-accent);
  background: linear-gradient(
    135deg,
    var(--empty-accent),
    var(--empty-accent-strong)
  );
  color: #ffffff;
  box-shadow: 0 12px 24px var(--empty-soft);
}

.empty-library-action--primary:hover {
  background: linear-gradient(135deg, #9a7427, var(--empty-accent-hover));
  border-color: var(--empty-accent-strong);
  box-shadow: 0 14px 28px var(--empty-soft);
}

.empty-library-action--secondary {
  border: 1px solid var(--empty-border);
  background: #ffffff;
  color: var(--empty-accent-strong);
}

.empty-library-action--secondary:hover {
  background: var(--empty-soft);
  border-color: var(--empty-accent);
}

.tree-view {
  list-style: none;
  padding: 0;
}

.tree-view.row-layout {
  display: flex;
  flex-wrap: wrap;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 6px;
  align-items: stretch;
  gap: 10px;
  justify-content: flex-start;
}

.tree-view.row-layout .folder-item {
  flex: 0 1 calc((100% - 30px) / 4);
  width: calc((100% - 30px) / 4);
  min-width: 0;
  max-width: calc((100% - 30px) / 4);
  margin-right: 0;
  box-sizing: border-box;
}

.folder-item {
  position: relative;
  margin-bottom: 10px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: visible;
}

.folder-header {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between; /* allinea titolo e menu */
  gap: 10px;
  padding: 8px 12px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e3e3e3;
  transition: background-color 0.2s;
}
.folder-header:hover {
  background-color: #e6f0fa;
}
.folder-header.menu-open {
  background-color: #e6f0fa !important;
}
.folder-header.menu-open:hover {
  background-color: #e6f0fa;
}
.folder-header span {
  display: flex;
  gap: 10px;
}
.folder-header i.fa-folder-plus,
.folder-header i.fa-folder-minus,
.folder-header i.fa-folder,
.folder-header i.fa-folder-open,
.folder-header i.fa-chevron-down,
.folder-header i.fa-chevron-up {
  color: #3498db;
  font-size: 18px;
}

.folder-header:hover i,
.folder-header.menu-open i {
  color: #1e87c9;
}

.file-list {
  list-style: none;
  padding-left: 25px;
  margin: 0;
  padding: 8px;
  min-height: 32px; /* mantiene altezza minima anche senza file */
}

.tree-view.row-layout .file-list {
  padding-left: 0;
}

.file-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px 6px 20px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.file-item:hover {
  background-color: #f0f0f0;
}

.file-item i.fa-file-excel {
  color: #27ae60;
}

.content {
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tableheader {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 1rem;
  position: relative;
  height: 3rem;
}

.selectedFile {
  font-size: 18px;
  color: #333;
  font-weight: normal;
  margin: 0;
  flex: 1;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
}

.buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.75rem;
  background-color: #ffffff;
  border-radius: 12px;
  transition: box-shadow 0.3s ease;
}

.closePDC {
  font-size: 1.5rem;
  color: #6c6c6c;
  cursor: pointer;
  position: absolute;
  right: 10px;
}

.closePDC:hover {
  color: rgb(143, 143, 143);
}

/* .buttons:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
} */

.buttons > button {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.8rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent;
}

.buttons > button:hover {
  background-color: #f0f0f0;
  transform: translateY(-1px);
}

.buttons > button:active {
  transform: translateY(0);
  background-color: #e0e0e0;
}

.action-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f0f0f0;
}
.uploadingPBA {
  background-color: #007bff !important;
  color: white !important;
  cursor: default !important;
}
.uploadingPBA i {
  color: white !important;
  cursor: default !important;
}
.toolicon {
  font-size: 1.1rem;
  color: #666;
}

.btninput {
  display: flex;
  align-items: center;
  gap: 7px;
}

.hidden-file-input {
  display: none;
}

.table-container {
  overflow-x: auto;
}

#excelTable {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2rem;
}

#excelTable th,
#excelTable td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 14px;
  text-align: center;
}

#excelTable .header-row th {
  background-color: #f4f4f4;
  font-weight: bold;
  color: #333;
}
#excelTable td:nth-child(3) {
  text-align: left;
}

.row-index {
  background-color: #f9f9f9;
  text-align: center;
  width: 40px;
  font-weight: 500;
}

.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  margin-top: 2rem;
  width: 70rem !important;
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.dashboard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
}
.ultimamodifica {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 1rem;
}

.savebutton {
  cursor: default !important;
  font-size: 1.2rem;
  cursor: pointer;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.3s ease;
}
.savebutton.unsaved {
  cursor: pointer !important;
  color: rgb(33, 105, 81);
  transform: scale(1.08);
}
/* .savebutton.unsaved:hover {
  color: rgb(24, 79, 61);
  transform: scale(1.1);
} */
.addRowButton.unsaved {
  background-color: #fbf9dd;
  transition: background-color 0.3s ease;
}
.addRowButton.unsaved:hover {
  background-color: #f7f3c1;
}
.cancelbutton {
  cursor: default !important;
  font-size: 1.2rem;
  padding-top: 0.1rem;
  cursor: pointer;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.2s ease;
}
.cancelbutton.unsaved {
  opacity: 1;
  cursor: pointer !important;
  color: rgb(180, 39, 29);
  transform: scale(1.08);
  /*color: #ffa500; o un altro colore che preferisci */
}
.savebuttondiv:not(.unsaved):hover {
  background-color: inherit !important; /* Mantieni il colore di sfondo */
  cursor: default !important; /* Cursore non interattivo */
}
.savebuttondiv:not(.unsaved) span {
  color: #cbcaca;
}
.nochanges-message {
  width: 14rem;
  position: absolute;
  right: 22rem;
  color: #5f6469;
}

.ultimamodificatext {
  font-size: 0.9em;
  color: #666;
  margin-left: 1rem;
  font-style: italic;
}

.riga {
  transition: background-color 0.3s;
}

.row-deleting {
  background-color: #ffcccc;
  transition: opacity 0.7s;
  opacity: 0;
}

.highlight-row {
  background-color: #f0f0f0;
}

.provisional-row {
  background-color: #e6f3ff;
}

.row-index {
  width: 50px;
  text-align: center;
}

td,
th {
  border: 1px solid #ddd;
  padding: 8px;
}

td[contenteditable="true"] {
  cursor: text;
}

td.modified-cell {
  background-color: #cee9cb !important;
  /* background-color: #fff3cd; */
}
td.error-cell {
  background-color: #f8d7da !important;
}

.has-hidden-description {
  position: relative;
}

.info-icon-hidden {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 0.8em;
  color: #007bff;
}

.custom-tooltip {
  position: absolute;
  background: #333;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  z-index: 1000;
}

.delete-column {
  width: 50px;
  text-align: center;
}

.delete-button {
  cursor: pointer;
  background: none;
  border: none;
  font-size: 1em;
}

.delete-button.active {
  color: red;
}

.noRowsPDC {
  text-align: center;
  padding: 20px;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}
.modal-content button {
  margin: 10px;
  padding: 8px 16px;
  cursor: pointer;
}
.add-client-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
.add-client-content button {
  width: 10rem;
  margin: 10px;
  padding: 8px 16px;
  cursor: pointer;
  margin: 0 auto;
}
.btn-modal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.2s ease;
  min-width: 100px;
}

/* Rosso Elimina */
.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

/* Grigio “Annulla” */
.btn-secondary {
  background-color: #eef1f4;
  border-color: #d5dce4;
  color: #374151;
}

.btn-secondary:hover {
  background-color: #e3e8ed;
  border-color: #c4ced8;
}
.ellipsis-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.folder-header .fa-ellipsis {
  cursor: pointer;
  color: #666;
  font-size: 1.3rem;
}

.folder-header .fa-ellipsis:hover {
  color: #333;
}

.context-menu {
  position: absolute !important;
  top: calc(100% + 0.5rem) !important;
  right: 0;
  left: auto !important;
  transform: none;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  z-index: 99999 !important;
  margin-top: 0;
  min-width: 140px;
  font-size: 0.9rem;
  padding: 4px 0;
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu li {
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.context-menu li:hover {
  background: #f0f0f0;
}

.context-menu i {
  width: 16px;
  font-size: 0.9em;
}

.btn-primary {
  background-color: #1474bd;
  border-color: #1474bd;
  color: white;
}

.btn-primary:hover {
  background-color: #115f9b;
  border-color: #0f568d;
}
.modal-client {
  width: 540px; /* più largo → più leggibile */
  max-width: 92vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  padding: 2rem 2.2rem;
  position: relative;
  overflow: hidden;
}

.modal-client h3 {
  margin: 0 0 1.6rem 0;
  font-size: 1.4rem;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
}
/* Grid per i due campi testo */
.client-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.1rem;
  margin-bottom: 1.8rem;
}
.client-form-grid input::placeholder {
  font-size: 0.82rem;
}
.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.form-field label {
  font-size: 0.92rem;
  font-weight: 500;
  color: #444;
}

.form-field input {
  padding: 0.75rem 1rem;
  border: 1px solid #d1d9e0;
  border-radius: 8px;
  font-size: 0.98rem;
  transition: all 0.2s ease;
}

.form-field input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15);
}

/* Sezione file */
.file-import-section {
  margin: 1.6rem 0 2rem;
}

.file-note {
  font-size: 0.86rem;
  color: #64748b;
  text-align: center;
  margin-bottom: 1.2rem;
  font-style: italic;
}

.file-upload-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.1rem 1.3rem;
  margin-bottom: 1rem;
  transition: all 0.2s ease;
}

.file-upload-card:hover {
  border-color: #cbd5e1;
  background: #f9fbfd;
}

.file-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: #334155;
  margin-bottom: 0.6rem;
}

.file-input-wrapper {
  position: relative;
}

.file-input-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1rem;
  background: white;
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.94rem;
  color: #64748b;
  transition: all 0.2s;
}

.file-input-label:hover {
  border-color: #3498db;
  color: #1e40af;
  background: #eff6ff;
}

.file-input-label i {
  color: #16a34a;
  font-size: 1.1rem;
}

.file-input-wrapper input[type="file"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

/* Pulsante anteprima */
.btn-preview {
  margin-top: 0.8rem;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  font-size: 0.88rem;
  padding: 0.45rem 1rem;
  border-radius: 6px;
  transition: all 0.2s;
}

.btn-preview:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}

/* Pulsanti principali */
.button-row {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  margin-top: 1.8rem;
}

.btn-modal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.6rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
  border: 1px solid transparent;
}

.btn-primary {
  background: #1474bd;
  border-color: #1474bd;
  color: white;
}

.btn-primary:hover {
  background: #115f9b;
  border-color: #0f568d;
  transform: translateY(-1px);
}

.btn-secondary {
  background: #eef1f4;
  border-color: #d5dce4;
  color: #374151;
}

.btn-secondary:hover {
  background: #e3e8ed;
  border-color: #c4ced8;
}

/* Messaggio di errore/warning */
.warning-message {
  margin-top: 1.4rem;
  padding: 0.9rem;
  background: #fef2f2;
  color: #991b1b;
  border-radius: 8px;
  font-size: 0.92rem;
  text-align: center;
  border: 1px solid #fecaca;
}

.modal-client {
  width: 620px;
}

.file-import-section {
  margin: 1.25rem 0 1.65rem;
}

.file-note {
  margin-bottom: 0.9rem;
}

.file-upload-card {
  padding: 0.85rem 1rem;
  margin-bottom: 0.75rem;
}

.file-label {
  margin-bottom: 0.55rem;
}

.file-card-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  gap: 0.65rem;
}

.file-card-actions .file-input-wrapper {
  min-width: 0;
}

.file-card-actions .file-input-label {
  min-height: 2.45rem;
  padding: 0.5rem 0.85rem;
}

.file-card-actions .file-input-label i {
  font-size: 1rem;
}

.model-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.45rem;
  padding: 0.5rem 0.85rem;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.88rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
}

.model-download-btn:hover {
  background: #dbeafe;
  border-color: #93c5fd;
  transform: translateY(-1px);
}

.input-row {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.input-row input {
  flex: 1;
  height: 1.5rem;
}

.file-section {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  margin-top: 0.8rem;
  margin-bottom: 1rem;
}
.file-section input {
  width: 14.75rem;
}

.file-note {
  font-size: 0.85rem;
  color: #555;
}

.button-row {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}
.rinomina-div {
  min-width: 18rem;
  display: flex;
  flex-direction: column; /* Dispone gli elementi in colonna */
  align-items: center; /* Centra orizzontalmente */
  gap: 1rem; /* Spazio tra gli elementi */
}

.rinomina-div input {
  height: 2rem;
  width: 100%; /* Per garantire che l'input occupi tutta la larghezza disponibile */
  max-width: 300px; /* Opzionale: limita la larghezza massima */
}

.button-group {
  display: flex;
  gap: 1rem; /* Spazio tra i pulsanti */
  justify-content: center; /* Centra i pulsanti orizzontalmente */
}
.excelbilancio {
  top: -24px;
  right: 0px;
}
.warning {
  margin-top: 1.5rem;
}
.no-files-message {
  font-style: italic;
  font-size: 0.92rem;
  color: rgb(101, 101, 101);
  display: flex;
  align-items: center;
  padding: 7px 20px 6px 20px;
}
.add-file-button {
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  color: #3498db;
  margin-left: 0.5rem;
  padding: 3px 6px;
  transition: all 0.3s ease;
}
.add-file-button:hover {
  color: #1e87c9;
  background: rgb(237, 237, 237);
}

/* Restyling workspace Bilanci Analitici */
.main-container {
  box-sizing: border-box;
  width: 100%;
  padding: 0.75rem clamp(1rem, 5vw, 6rem) 2.25rem;
}

.library-page-header {
  position: relative;
  display: flex;
  width: 100%;
  max-width: none;
  min-height: 5.85rem;
  align-items: center;
  box-sizing: border-box;
  margin: 0 auto 0.675rem;
  padding: 0.72rem 13.5rem 0.72rem 1rem;
  gap: 0.9rem;
  overflow: hidden;
  border: 1px solid rgba(150, 108, 28, 0.11);
  border-radius: 12px;
  background: linear-gradient(105deg, #fffdf7 0%, #fbf4e3 68%, #f6e8ca 100%);
  box-shadow: 0 7px 20px rgba(150, 108, 28, 0.06);
}

.library-page-header__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 3.7rem;
  height: 3.7rem;
  flex: 0 0 3.7rem;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #f1dfae;
  border-radius: 12px;
  background: #fff3d7;
}

.library-page-header__icon .library-icon {
  width: 82%;
  height: 82%;
  object-fit: contain;
}

.library-page-header__copy {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.library-page-header__title-row {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.7rem;
}

.library-page-header__title {
  margin: 0;
  color: #15334b;
  font-size: 1.42rem;
  font-weight: 750;
  letter-spacing: -0.015em;
  line-height: 1.15;
}

.library-page-header__subtitle {
  margin: 0.3rem 0 0;
  color: #657c88;
  font-size: 0.82rem;
  line-height: 1.35;
  text-align: left;
}

.library-page-header__visual {
  position: absolute;
  z-index: 0;
  display: block;
  pointer-events: none;
  user-select: none;
}

.library-page-header__visual--bilancio {
  right: 1.2rem;
  bottom: -4.1rem;
  width: 11.5rem;
  opacity: 0.28;
}

.libreria-bilanci {
  --library-accent: #216951;
  --library-accent-hover: #195640;
  --library-accent-soft: #eef7f3;
  --library-border: #d9e5df;
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 1rem;
  gap: 1rem;
  border: 1px solid var(--library-border);
  border-radius: 16px;
  background: linear-gradient(145deg, #f4f8f7 0%, #edf3f1 100%);
  box-shadow: 0 12px 30px rgba(33, 80, 62, 0.08);
}

.selector-container {
  position: relative;
  z-index: 2;
  overflow: visible;
  border: 1px solid #dce6e2;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
}

.content {
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 1px solid #dce6e2;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
}

.selector-container.collapsed {
  max-height: 4.15rem;
  overflow: hidden;
}

.selector-header {
  min-height: 4.05rem;
  box-sizing: border-box;
  padding: 0.72rem 1rem;
  gap: 1rem;
  border-bottom-color: #e5ece8;
}

.header-title {
  min-width: 0;
  margin-left: 0;
  gap: 0.65rem;
}

.clients-title-icon {
  display: inline-flex;
  width: 2.2rem;
  height: 2.2rem;
  flex: 0 0 2.2rem;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--library-accent-soft);
  color: var(--library-accent);
  font-size: 1rem;
}

.selector-header h3 {
  color: #213a31;
  font-size: 1rem;
  font-weight: 750;
}

.client-count {
  display: inline-flex;
  min-width: 1.65rem;
  height: 1.65rem;
  padding: 0 0.42rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #cfe0d8;
  border-radius: 999px;
  background: #f5faf7;
  color: var(--library-accent);
  font-size: 0.72rem;
  font-weight: 750;
}

.selector-header .toolbar {
  align-items: center;
  gap: 0.45rem;
}

.add-button,
.layout-button,
.espandi-button {
  display: inline-flex;
  min-height: 2.45rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #d7e3dd;
  border-radius: 9px;
  background: #ffffff;
  color: #2d443b;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, color 0.18s ease;
}

.add-button {
  margin-right: 0.35rem;
  padding: 0.58rem 0.95rem;
  gap: 0.45rem;
  border-color: var(--library-accent);
  background: var(--library-accent);
  color: #ffffff;
  font-size: 0.84rem;
  font-weight: 700;
  box-shadow: 0 5px 12px rgba(33, 105, 81, 0.17);
}

.layout-button,
.espandi-button {
  width: 2.45rem;
  padding: 0;
}

.add-button i,
.layout-button i,
.espandi-button i {
  margin: 0;
  color: currentColor;
  font-size: 0.9rem;
}

.add-button:hover {
  border-color: var(--library-accent-hover);
  background: var(--library-accent-hover);
  box-shadow: 0 6px 14px rgba(33, 105, 81, 0.22);
}

.layout-button:hover,
.espandi-button:hover {
  border-color: #c8d8d0;
  background: #f4f8f6;
  color: var(--library-accent);
}

.selector-content {
  min-height: 0;
  padding: 0.9rem 1rem 1rem;
  background: #f2f6f5;
}

.selector-content--empty {
  min-height: 9.5rem;
  padding: 1.25rem 1.5rem;
  background: #ffffff;
}

.tree-view {
  margin: 0;
}

.tree-view.row-layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(18rem, 100%), 1fr));
  align-items: start;
  width: 100%;
  padding: 0;
  gap: 0.75rem;
}

.tree-view.row-layout .folder-item {
  width: auto;
  max-width: none;
  margin: 0;
}

.folder-item {
  margin: 0 0 0.65rem;
  overflow: visible;
  border: 1px solid #d9e3df;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(35, 61, 51, 0.05);
}

.folder-item.menu-open {
  z-index: 10;
}

.folder-item:last-child {
  margin-bottom: 0;
}

.folder-header {
  min-height: 3rem;
  box-sizing: border-box;
  padding: 0.72rem 0.9rem;
  gap: 0.75rem;
  border-bottom: 1px solid #d9e3df;
  background: #f8faf9;
  color: #263d35;
}

.folder-item:not(.is-open) .folder-header {
  border-bottom-color: transparent;
}

.folder-header:hover,
.folder-header.menu-open {
  background: #f0f5f3 !important;
}

.folder-item.is-open .folder-header {
  background: #eef6f1;
  box-shadow: inset 3px 0 0 var(--library-accent);
}

.client-file-upload-context {
  display: grid;
  gap: 0.7rem;
  margin-top: 0.15rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  background: #f7f9f8;
  text-align: left;
}

.client-file-upload-context-row {
  display: grid;
  grid-template-columns: minmax(8.5rem, 0.7fr) minmax(0, 1.3fr);
  align-items: baseline;
  gap: 0.75rem;
}

.client-file-upload-context-row span {
  color: #74817b;
  font-size: 0.78rem;
  font-weight: 650;
}

.client-file-upload-context-row strong {
  min-width: 0;
  color: #263d35;
  font-size: 0.88rem;
  overflow-wrap: anywhere;
}

.folder-header > span {
  min-width: 0;
  align-items: center;
  gap: 0.62rem;
  color: #263d35;
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
}

.folder-header i.fa-folder,
.folder-header i.fa-folder-open {
  color: #e9aa20;
  font-size: 1.15rem;
}

.folder-header i.fa-chevron-down,
.folder-header i.fa-chevron-up {
  margin-left: 0.12rem;
  color: #789087;
  font-size: 0.68rem;
}

.folder-header:hover i.fa-chevron-down,
.folder-header:hover i.fa-chevron-up,
.folder-header.menu-open i.fa-chevron-down,
.folder-header.menu-open i.fa-chevron-up,
.folder-header:hover .fa-ellipsis,
.folder-header.menu-open .fa-ellipsis {
  color: var(--library-accent-hover);
}

.folder-header:hover i.fa-folder,
.folder-header:hover i.fa-folder-open,
.folder-header.menu-open i.fa-folder,
.folder-header.menu-open i.fa-folder-open {
  color: #d6960d;
}

.folder-header .fa-ellipsis {
  color: #6f7d78;
  font-size: 1rem;
}

.ellipsis-wrapper {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
}

.ellipsis-wrapper:hover {
  background: #e5efe9;
}

.file-list {
  min-height: 0;
  padding: 0.45rem 0.45rem 0.55rem 1.2rem;
  background: #ffffff;
}

.tree-view.row-layout .file-list {
  padding: 0.45rem;
}

.file-item {
  min-height: 2.35rem;
  box-sizing: border-box;
  padding: 0.52rem 0.7rem;
  gap: 0.6rem;
  border-radius: 7px;
  color: #344a42;
  font-size: 0.84rem;
  text-align: left;
}

.file-item:hover {
  background: #f1f6f3;
}

.file-item.active {
  background: #e7f4ed;
  color: #125f45;
  font-weight: 700;
}

.file-item i.fa-file-excel {
  color: #168553;
  font-size: 0.95rem;
}

.no-files-message {
  min-height: 2.35rem;
  box-sizing: border-box;
  padding: 0.45rem 0.65rem;
  color: #76837e;
  font-size: 0.78rem;
  text-align: left;
}

.add-file-button {
  display: inline-flex;
  width: 1.7rem;
  height: 1.7rem;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding: 0;
  border: 1px solid #cfe0d8;
  background: #f5faf7;
  color: var(--library-accent);
}

.add-file-button:hover {
  border-color: #b7d0c4;
  background: #e9f4ee;
  color: var(--library-accent-hover);
}

.context-menu {
  min-width: 9.5rem;
  padding: 0.3rem;
  border-color: #dce5e0;
  border-radius: 9px;
  box-shadow: 0 12px 28px rgba(24, 54, 43, 0.15);
}

.context-menu li {
  padding: 0.58rem 0.7rem;
  border-radius: 6px;
  color: #34483f;
}

.context-menu li:hover {
  background: #f1f6f3;
}

.content {
  padding: 0;
}

.tableheader {
  min-height: 4.6rem;
  height: auto;
  box-sizing: border-box;
  margin: 0;
  padding: 0.8rem 1rem;
  justify-content: space-between;
  border-bottom-color: #e4ebe7;
}

.selected-file-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.72rem;
  text-align: left;
}

.selected-file-icon {
  display: inline-flex;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--library-accent-soft);
  color: var(--library-accent);
  font-size: 1.05rem;
}

.selected-file-client {
  display: block;
  max-width: min(60vw, 48rem);
  overflow: hidden;
  color: #718078;
  font-size: 0.7rem;
  font-weight: 650;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selectedFile {
  position: static;
  width: auto;
  margin: 0.16rem 0 0;
  transform: none;
  color: #20382f;
  font-size: 1rem;
  font-weight: 750;
  text-align: left;
}

.closePDC {
  position: static;
  display: inline-flex;
  width: 2.35rem;
  height: 2.35rem;
  flex: 0 0 2.35rem;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #dbe4df;
  border-radius: 8px;
  background: #ffffff;
  color: #64736d;
  font-size: 1rem;
  cursor: pointer;
}

.closePDC:hover {
  border-color: #cbd8d1;
  background: #f4f7f5;
  color: #34483f;
}

.table-container {
  padding: 0;
  overflow-x: auto;
}

.dashboard {
  display: flex;
  margin: 0;
  padding: 0.78rem 1rem;
  gap: 0.85rem;
  border-bottom: 1px solid #e5ece8;
  background: #ffffff;
}

.buttons {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  flex-wrap: wrap;
  gap: 0.4rem;
  border-radius: 0;
}

.buttons > button,
.buttons > .download-menu > .download-menu-trigger {
  width: auto;
  min-height: 2.65rem;
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 0.58rem 0.88rem;
  gap: 0.55rem;
  border: 1px solid #dce6e1;
  border-radius: 9px;
  background: #ffffff;
  color: #263c34;
  font-size: 0.82rem;
  font-weight: 650;
  white-space: nowrap;
  box-shadow: 0 2px 5px rgba(35, 63, 52, 0.035);
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, color 0.18s ease;
}

.buttons > button:first-child {
  border-color: var(--library-accent);
  background: linear-gradient(180deg, #28795f 0%, var(--library-accent) 100%);
  color: #ffffff;
  box-shadow: 0 5px 12px rgba(33, 105, 81, 0.2);
}

.buttons > button:first-child .toolicon {
  color: #ffffff;
}

.buttons > button:hover:not(:disabled),
.buttons > .download-menu > .download-menu-trigger:hover:not(:disabled) {
  border-color: #cfd9d4;
  background: #f5f7f6;
  transform: none;
  box-shadow: 0 4px 10px rgba(33, 80, 62, 0.08);
}

.buttons > button:first-child:hover:not(:disabled) {
  border-color: var(--library-accent-hover);
  background: linear-gradient(
    180deg,
    #246f58 0%,
    var(--library-accent-hover) 100%
  );
  color: #ffffff;
}

.buttons > button:disabled {
  opacity: 1;
  border-color: #e4e9e6;
  background: #f3f5f4;
  color: #a9b1ad;
  cursor: not-allowed;
  box-shadow: none;
}

.buttons > button:disabled :is(i, span) {
  color: #a9b1ad;
}

.buttons .toolicon,
.buttons .download-menu i {
  color: #47534e;
  font-size: 0.94rem;
}

.buttons .savebuttondiv {
  min-width: 6.5rem;
  justify-content: center;
}

.buttons .savebuttondiv:not(.unsaved) {
  border-color: #e2e6e8;
  background: #f1f3f4;
  color: #a9afb4;
  box-shadow: none;
}

.buttons .savebuttondiv:not(.unsaved) :is(i, span) {
  color: #a9afb4;
}

.buttons .savebuttondiv.unsaved {
  background: #fbf9dd;
}

.download-menu {
  position: relative;
  width: auto;
  flex: 0 0 auto;
}

.ultimamodifica {
  flex: 0 0 auto;
  margin: 0 0 0 auto;
  align-self: center;
  white-space: nowrap;
}

.ultimamodificatext {
  margin-left: 0;
  color: #65766f;
  font-size: 0.75rem;
}

.nochanges-message {
  position: static;
  width: auto;
  color: #607069;
  font-size: 0.75rem;
}

#excelTable {
  width: calc(100% - 2rem);
  min-width: 48rem;
  margin: 1rem;
  overflow: hidden;
  border: 1px solid #d6e1e8;
  border-radius: 11px;
  border-collapse: separate;
  border-spacing: 0;
  color: #243b4d;
}

#excelTable th,
#excelTable td {
  padding: 0.68rem 0.78rem;
  border: 0;
  border-right: 1px solid #e4ebf0;
  border-bottom: 1px solid #e2e9ee;
  color: #243b4d;
  font-size: 0.82rem;
  line-height: 1.28;
  vertical-align: middle;
}

#excelTable .header-row th {
  background: #eef2f4;
  color: #304658;
  font-size: 0.78rem;
  font-weight: 750;
}

#excelTable
  tr:nth-child(odd):not(.header-row):not(.highlight-row):not(
    .provisional-row
  ):not(.row-deleting)
  > td:not(.modified-cell):not(.error-cell) {
  background: #f9f9f9;
}

#excelTable tr:last-child > td,
#excelTable tr:last-child > th {
  border-bottom: 0;
}

#excelTable :is(th, td):last-child {
  border-right: 0;
}

#excelTable .highlight-row > td {
  background: #fff1c7 !important;
}

#excelTable .provisional-row > td:not(.modified-cell):not(.error-cell) {
  background: #eaf4fb;
}

#excelTable .row-index {
  width: 3.2rem;
  color: #798995;
  font-size: 0.72rem;
  font-weight: 500;
  text-align: center;
}

.file-selection-empty,
.table-loading-state {
  display: flex;
  min-height: 8.5rem;
  box-sizing: border-box;
  padding: 1.5rem;
  align-items: center;
  justify-content: flex-start;
  gap: 0.85rem;
  color: #6c7c75;
  text-align: left;
}

.file-selection-empty {
  background: #f8faf9;
}

.file-selection-empty-icon {
  display: inline-flex;
  width: 3rem;
  height: 3rem;
  flex: 0 0 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border: 1px solid #f1dfae;
  background: #fff3d7;
  color: #e2a117;
  font-size: 1.2rem;
}

.file-selection-empty strong {
  display: block;
  margin-bottom: 0.2rem;
  color: #294038;
  font-size: 0.95rem;
}

.file-selection-empty p {
  max-width: 34rem;
  margin: 0;
  color: #718078;
  font-size: 0.9rem;
  line-height: 1.45;
  text-align: left;
}

.table-loading-state {
  font-size: 0.84rem;
}

.table-loading-state i {
  color: var(--library-accent);
}

@media (max-width: 760px) {
  .main-container {
    padding-inline: 0.75rem;
  }

  .library-page-header {
    min-height: auto;
    padding: 0.8rem 1rem;
  }

  .library-page-header__title-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.4rem;
  }

  .library-page-header__visual {
    display: none;
  }

  .selector-header,
  .dashboard {
    align-items: stretch;
    flex-direction: column;
  }

  .selector-header .toolbar,
  .ultimamodifica {
    width: 100%;
    margin-left: 0;
  }

  .add-button {
    flex: 1 1 auto;
  }

  .selected-file-client {
    max-width: 62vw;
  }
}
</style>
